import React, { ReactNode } from 'react';
import cx from 'classnames';

import { rowHeight } from '../../../constants';

interface DataCardRowProps {
    children: ReactNode;
    index: number;
}

export const DataCardRow = ({
    children,
    index,
}: DataCardRowProps): JSX.Element => (
    <tr
        className={cx({
            'bg-highlight-palelavender': index % 2 === 0,
        })}
        style={{ height: rowHeight }}
    >
        <td className="p-2 flex items-center justify-between">{children}</td>
    </tr>
);
